module.exports = __webpack_public_path__ + "static/media/manTrMenus.7bef6874.png";